import { UPDATE_TRC_STATUS_API } from "../../constants/api";
import { TableRowData } from "../../types/dataType";
import axios from "../fetch/fetch";

export const updateTRCDocumentStatusAPI = async (id: string, status: string): Promise<TableRowData> => {
    const body = {
        id: id,
        status: status,
    };
    const res = await axios.put(UPDATE_TRC_STATUS_API, body);
    return res.data;
};
